export enum SocialLinks {
    Instagram = 'instagram',
    LinkedIn = 'linked_in',
    Facebook = 'facebook',
}
